const ANY_PARTY = "any";
const DEMOCRAT = "democrat";
const REPUBLICAN = "republican";
const INDEPENDENT = "independent";
const OTHER = "other";

const ALL_PARTIES_IN_ORDER = [DEMOCRAT, REPUBLICAN, INDEPENDENT, OTHER];

export default {
  ANY_PARTY,
  DEMOCRAT,
  REPUBLICAN,
  INDEPENDENT,
  OTHER,
  ALL_PARTIES_IN_ORDER
};
